import {stage} from './stage';

type ConfigShape = {
    [key in 'prod' | 'test' | 'dev' | 'ide']: {
        enabled: boolean;
        policyStoreId: string;
        region: string;
    };
};

const config: ConfigShape = {
    prod: {
        enabled: true,
        policyStoreId: 'DeYfPQbrN7s2DW3xnN4rDt',
        region: 'us-west-2',
    },
    test: {
        enabled: true,
        policyStoreId: 'WsLY92mivUZjES9a6VU84Z',
        region: 'us-west-2',
    },
    dev: {
        enabled: true,
        policyStoreId: 'A928xpmZQBv9h5FSjckwte',
        region: 'us-west-2',
    },
    ide: {
        enabled: true,
        policyStoreId: 'A928xpmZQBv9h5FSjckwte',
        region: 'us-west-2',
    },
};

export default config[stage];
